var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 13,
    viewBox: "0 0 8 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.892965 0.342004C0.478387 0.79605 0.478387 1.52951 0.892965 1.98356L5.01749 6.50073L0.892965 11.0179C0.478387 11.472 0.478387 12.2054 0.892965 12.6595C1.30754 13.1135 1.97725 13.1135 2.39183 12.6595L7.2711 7.31569C7.68568 6.86164 7.68568 6.12818 7.2711 5.67414L2.39183 0.330362C1.98788 -0.112042 1.30754 -0.112042 0.892965 0.342004Z",
    fill: "#444444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowIcon);
export default __webpack_public_path__ + "static/media/right-arrow-Icon.2cb8b9bd278b879fd9815a002cd47806.svg";
export { ForwardRef as ReactComponent };